var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9333 15.8392H36.8661V14.1601H38.9325V14.1578L25.9668 1.1921L27.1589 0L42.1592 14.9997L27.1589 30L25.9668 28.8102L38.9333 15.8416V15.8392Z",
    fill: "#010002"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.00031662 14.1602H4.21289V15.8395H-0.00031662V14.1602Z",
    fill: "#010002"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.119 14.1602H26.333V15.8395H22.119V14.1602Z",
    fill: "#010002"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4919 14.1602H33.7051V15.8395H29.4919V14.1602Z",
    fill: "#010002"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7464 14.1602H18.959V15.8395H14.7464V14.1602Z",
    fill: "#010002"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37337 14.1602H11.5859V15.8395H7.37337V14.1602Z",
    fill: "#010002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.94cfe4079f783e332b26e8fa76d940eb.svg";
export { ForwardRef as ReactComponent };